import axios from "axios";
import { useGlobalStore } from "@/stores";

let piniaStore;

export const setStore = (storeInstance) => {
  piniaStore = storeInstance;
};

// Create an Axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // Change this to your API base URL
  timeout: 60000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor (Example: Adding Authorization Token)
api.interceptors.request.use(
  (config) => {
    // You can dynamically add token if needed
    if (config.url != "/api/auth/refresh") {
      const token = piniaStore.accessToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor (Example: Global Error Handling)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("🔴 API Error interceptor triggered. Status:", error.response?.status);
    if (
      error.response &&
      error.response.data &&
      error.response.data.error &&
      (error.response.data.error === "Invalid token" ||
        error.response.data.error === "Token expired")
    ) {
      await api
        .post("/api/auth/refresh", {
          refreshToken: piniaStore.refreshToken,
        })
        .then((res) => {
          piniaStore.setTokens(res.data);
          window.location.reload();
        })
        .catch(() => {
          piniaStore.setTokens({ accessToken: null, refreshToken: null });
          piniaStore.logout();
        });
    } else if (error.response?.status === 401) {
      piniaStore.setTokens({ accessToken: null, refreshToken: null });
      piniaStore.logout();
    }

    // Handle validation errors (400 status)
    if (error.response?.status === 400) {
      let errorText = null;
      const responseData = error.response?.data;

      console.log("400 Error received. Response data:", responseData);

      // Try to extract error message from various possible structures
      if (responseData?.errors && typeof responseData.errors === 'object') {
        // Field-level validation errors
        console.log("Field-level validation errors detected");
        const errorEntries = Object.entries(responseData.errors);
        errorText = errorEntries
          .map(([field, message]) => `${field}: ${message}`)
          .join(" | ");
      } else if (responseData?.message) {
        // General error message
        console.log("General error message detected");
        errorText = responseData.message;
      } else if (typeof responseData === 'string') {
        // Error is a plain string
        console.log("Error is plain string");
        errorText = responseData;
      } else if (responseData?.error) {
        // Error in .error field
        console.log("Error in .error field");
        errorText = responseData.error;
      }

      // Show error even if structure is unexpected
      if (!errorText && responseData) {
        console.log("Extracting from unexpected structure");
        errorText = JSON.stringify(responseData).substring(0, 200);
      }

      if (errorText) {
        console.log("✓ Displaying validation error:", errorText);
        try {
          const globalStore = useGlobalStore();
          globalStore.showSnackbar({
            show: true,
            text: errorText,
            timeout: 5000,
            type: "error",
            position: "top right",
          });
          console.log("✓ Snackbar displayed successfully");
        } catch (snackbarError) {
          console.error("Failed to show snackbar:", snackbarError);
        }
      } else {
        console.warn("No error text could be extracted from 400 response");
      }
    }

    if (error.status != 500) {
      // store.dispatch("user/logout");
    }
    console.error(
      "API Error:",
      error.response ? error.response.data : error.message
    );
    return Promise.reject(error);
  }
);

export default api;
